import { render, staticRenderFns } from "./ClientView.vue?vue&type=template&id=030514ce&scoped=true"
import script from "./ClientView.vue?vue&type=script&lang=js"
export * from "./ClientView.vue?vue&type=script&lang=js"
import style0 from "./ClientView.vue?vue&type=style&index=0&id=030514ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030514ce",
  null
  
)

export default component.exports